export enum Periodicity {
	// Day,
	Week,
	Month,
	Year,
	AllTime,
}
